<template>
  <div>
    <div class="row mb-5 import-users-row">
      <div class="col-2 offset-10">
        <div class="row mb-2">
          <div class="col-12">
            <button
              @click="importUsersBtnClicked"
              class="btn btn-block btn-add"
            >
              <i class="fa fa-users"></i>
              Importar Usuários
            </button>
            <input
              hidden
              type="file"
              id="importUsersInput"
              @change="importUsers"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a
              :href="$store.getters.url + '/layouts/users'"
              target="_blank"
              class="btn btn-block btn-add"
            >
              <i class="fa fa-download"></i>
              Baixar modelo
            </a>
          </div>
        </div>
      </div>
    </div>
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
      @fieldUpdated="fieldUpdated"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      crudName: "Usuário",
      newText: "Cadastrar Usuário",
      table: "usersTable",
      columns: [
        "id",
        "name",
        "register",
        "photo_http",
        "company_id",
        "branch_id",
        "sector_id",
        "role_id",
        "actions",
      ],
      tableData: [
        "id",
        "name",
        "register",
        "photo_http",
        "company_id",
        "branch_id",
        "sector_id",
        "role_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        sortable: [
          "id",
          "name",
          "register",
          "company_id",
          "branch_id",
          "sector_id",
          "role_id",
        ],
        filterable: [
          "id",
          "name",
          "register",
          "company_id",
          "branch_id",
          "sector_id",
          "role_id",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: "Nome",
          register: "Matricula",
          company_id: "Empresa",
          branch_id: "Unidade",
          sector_id: "Departamento",
          role_id: "Cargo",
          id: "#",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.fantasy_name : "";
          },
          branch_id: function (h, row, index) {
            return row.branch ? row.branch.name : "";
          },
          sector_id: function (h, row, index) {
            return row.sector ? row.sector.name : "";
          },
          role_id: function (h, row, index) {
            return row.role ? row.role.name : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company", "branch", "sector", "role"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "users/",
      dataForm: {
        title: {
          add: "Novo Usuário",
          edit: "Editar Usuário",
          view: "Visualizar Usuário",
          icon: "fa fa-pen",
        },
        button: {
          back: "/users",
        },
        url: {
          model: "users",
        },
        messages: {
          success: {
            add: "Usuário cadastrado com sucesso!",
            edit: "Usuário alterado com sucesso!",
          },
        },
        fields: [
          {
            name: "name",
            model: "name",
            label: "Nome",
            type: "text",
            isRequired: {
              add: true,
              edit: true,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "email",
            model: "email",
            label: "E-mail",
            type: "text",
            isRequired: {
              add: true,
              edit: true,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "cpf",
            model: "cpf",
            label: "CPF",
            type: "text",
            isRequired: {
              add: true,
              edit: true,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            mask: "###.###.###-##",
          },
          {
            name: "admission_date",
            model: "admission_date",
            label: "Data de admissão",
            type: "date",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "company_id",
            model: "company_id",
            label: "Empresa",
            type: "select",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["branch_id"],
            list_label: "fantasy_name",
          },
          {
            name: "branch_id",
            model: "branch_id",
            label: "Unidade",
            type: "select",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["sector_id"],
          },
          {
            name: "sector_id",
            model: "sector_id",
            label: "Departamento",
            type: "select",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["role_id"],
          },
          {
            name: "role_id",
            model: "role_id",
            label: "Cargo",
            type: "select",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
          },
          {
            name: "photo",
            model: "photo",
            label: "Foto",
            type: "file",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "phone",
            model: "phone",
            label: "Celular",
            type: "text",
            isRequired: {
              add: false,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            mask: "(##) # ####-####",
          },
          {
            name: "type_id",
            model: "type_id",
            label: "Tipo",
            type: "select",
            isRequired: {
              add: true,
              edit: true,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
          },
          {
            name: "password",
            model: "password",
            label: "Senha",
            type: "password",
            isRequired: {
              add: true,
              edit: false,
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
        ],
      },
    };
  },
  methods: {
    importUsersBtnClicked() {
      document.getElementById("importUsersInput").value = "";
      $("#importUsersInput").click();
    },
    importUsers() {
      $("#page_loader").show();
      const self = this;
      const api = self.$store.state.api + "import/users";
      self.error = "";

      const fd = new FormData();
      const file = document.getElementById("importUsersInput").files[0];
      if (file) {
        fd.append("file", file);
      } else return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$refs.usersTable.$refs.table.refresh();
          self.$message(
            "Sucesso",
            "Importação realizada com sucesso",
            "success"
          );
          $("#page_loader").hide();
        })
        .catch((error) => {
          document.getElementById("importUsersInput").value = "";
          if (error.response.data) {
            self.$message("Erro", error.response.data, "error");
          }
          $("#page_loader").hide();
        });
    },
    fieldUpdated: function (field) {
      const self = this;
      if (field.model == "company_id") {
        let filters = "&company_id=" + field.value;
        self.getBranches(filters);
      } else if (field.model == "branch_id") {
        let filters = "&branch_id=" + field.value;
        self.getSectors(filters);
      } else if (field.model == "sector_id") {
        let filters = "&sector_id=" + field.value;
        self.getRoles(filters);
      }
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        register: "register",
        company_id: "company[fantasy_name]",
        branch_id: "branch[name]",
        sector_id: "sector[name]",
        role_id: "role[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
    getCompanies: function (filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "companies?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then((response) => {
          let found = self.dataForm.fields.find((x) => x.name == "company_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function (filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then((response) => {
          let found = self.dataForm.fields.find((x) => x.name == "branch_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function (filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "sectors?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then((response) => {
          let found = self.dataForm.fields.find((x) => x.name == "sector_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoles: function (filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "roles?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then((response) => {
          let found = self.dataForm.fields.find((x) => x.name == "role_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUserTypes: function () {
      const self = this;
      const api = self.$store.state.api + "usertypes?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          let found = self.dataForm.fields.find((x) => x.name == "type_id");
          if (found) {
            found.list = response.data.data.filter((x) => x.id != 4);
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    self.getCompanies();
    self.getBranches();
    self.getSectors();
    self.getRoles();
    self.getUserTypes();
  },
  components: {
    BaseCrud,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/User/Crud.vue